// extracted by mini-css-extract-plugin
export default {"wrapper":"H46CuF"};